import carouselInit from "../js/src/carousel";
import {initMainHeader} from '../js/src/header-init';
import {getQuoteFormInit, scrollToQuoteForm} from "../js/src/get-quote-form";
import {addThirdPartyLoad, Http, Utils} from "@/js/src/utils";

import '../scss/pages/brand.scss';

initMainHeader();
carouselInit(8000);
global.scrollToQuoteForm = scrollToQuoteForm;
addThirdPartyLoad(() => {
    getQuoteFormInit();

    if (window.innerWidth <= Utils.screen.xs) {
        init();
        initStickyFilter();
    }
});


const returnToName = 'back';
const openState = {};
const openStateZero = {};
const baseFilterId = {};
let selectedFilter = {};
let urlFilter = [];
const filterPosition = {top: 0, bottom: 0, footer: 0, selected: 0, ts: 0, bs: 0};
let baseFilter, filterEl, productEl, filterLoader, selectedListEl, selectedBoxEl, filterColEl, abortController, pageId, filterSection, filterTmpEl, returnToPosition = 0;
const urlParams = new URLSearchParams(window.location.search);


/**
 *
 */
function init() {
    filterEl = document.getElementById('filter-box');
    productEl = document.getElementById('product-box');
    filterSection = document.getElementById('filter-section');
    filterColEl = document.getElementById('filter-col');
    filterLoader = document.getElementById('filter-loader');
    selectedListEl = document.getElementById('selected-list');
    selectedBoxEl = document.getElementById('selected-filter-box');
    filterTmpEl = document.getElementById('filter-tmp');
    pageId = document.getElementById('pageId').value;

    try {
        const goto = urlParams.get(returnToName);
        // if page loaded with goto query param
        if (goto) {
            returnToPosition = +goto || 0;
        }

        urlFilter = (urlParams.get('s') || '').split(',').filter(i => !!i);

        // init filter when page loaded without twig data
        filterStartRequest(urlFilter.join(',').trim());
        updateFilterPosition();
        initReturnToPosition(productEl);

    } catch (e) {
        console.warn(e);
    }
}

/**
 *
 * @param parent
 */
const initReturnToPosition = (parent) => {
    parent?.addEventListener('click', onProductClick);
}

/**
 *
 */
const onProductClick = (e) => {
    if (!(e.target.tagName === 'A' || e.target.parentElement.tagName === 'A')) {
        return
    }
    // add to current query url scroll position
    const scrollPosition = window.scrollY;

    // add new query param - goto
    urlParams.set(returnToName, scrollPosition.toString());
    updateQueryString();
}

const updateQueryString = () => {
    // create new url with all query params
    const newUrl = getUrlWithParams();

    window.history.replaceState({ path: newUrl }, '', newUrl);
}

/**
 *
 * @returns string
 */
const getUrlWithParams = () => {
    const url = `${window.location.origin}${window.location.pathname}`;

    return urlParams.size === 0 ? url : `${url}?${urlParams.toString()}`;
}

/**
 *
 * @param data
 */
function initFilterData(data) {
    decorateFilter(data.productsRootData || []);

    // init selected filters
    urlFilter.forEach(filterId => {
        if (baseFilterId[filterId]) {
            selectedFilter[filterId] = baseFilterId[filterId];
        }
    });

    urlFilter = [];
}

/**
 *
 * @param input
 * @param count
 */
function filterChange(input, count) {
    urlParams.delete('s');
    updateQueryString();

    if (!count && input.checked) {
        input.checked = false;
        return;
    }

    if (!baseFilter || !filterEl || !productEl) {
        return
    }

    if (input.checked) {
        selectedFilter[input.id] = baseFilterId[input.id];
    } else {
        delete selectedFilter[input.id];
    }

    filterStartRequest();
}

/**
 *
 */
function filterStartRequest(ids) {

    if (typeof ids == 'undefined') {
        filterStart()
    }

    if (abortController) {
        abortController.abort();
    }

    ids = typeof ids == 'undefined' ? Object.keys(selectedFilter).join(',') : ids;

    if (history.replaceState) {
        urlParams.delete(returnToName);

        if (ids) {
            urlParams.set('s', ids);
        } else {
            urlParams.delete('s');
        }

        updateQueryString();
    }

    sendFilterRequest(ids);
}

/**
 *
 * @param data
 */
function decorateFilter(data) {
    baseFilter = data;

    baseFilter.forEach(root => {
        let allZero = true;

        root.filterRootItems.forEach(f => {
            f.id = f.seoName || f.id;
            baseFilterId[f.id] = f;

            if (f.productsCount > 0) {
                allZero = false;
            }
        })

        openStateZero[root.id] = allZero;
    });
}

/**
 *
 * @param ids
 */
async function sendFilterRequest(ids) {
    abortController = new AbortController();

    const param = ids ? `?s=${ ids }` : '';
    const url = `/filterBrandProducts/${ pageId }${ param }`;
    const config = {
        signal: abortController.signal,
    };

    try {
        const res = await Http.getJson(url, config);
        const groups = Object.keys(res.groups);

        initFilterData(res);

        filterEl.innerHTML = baseFilter.map((f, i) => getNewFilter(f, i)).join('');
        productEl.style.opacity = 0;
        productEl.innerHTML = groups.length ?
            groups.map(i => getNewProduct(res.groups[i])).join('') :
            '<p class="not-found">No products found</p>';

        setTimeout(() => {
            updateSelected();
            window.bLazy.revalidate();

            // scroll to returnPosition
            if (returnToPosition) {
                window.scrollTo({top: returnToPosition, behavior: 'smooth'});
                returnToPosition = 0;
            }
        }, 100);
    } catch(err) {
        productEl.innerHTML = '<p class="not-found err">An error has occurred, please try again later</p>';
    } finally {
        filterEnd();
        setTimeout(() => {
            productEl.style.opacity = 1;
            updateFilterPosition();
        }, 300);
    }
}

/**
 *
 */
function filterStart() {
    updateSelected();
    window.scrollTo({top: filterPosition.selected, behavior: 'smooth'});
    showLoader();
}

/**
 *
 */
function filterEnd() {
    hideLoader();
}

function showLoader() {
    filterLoader.classList.add('show');
}
function hideLoader() {
    filterLoader.classList.remove('show');
}


/**
 *
 */
function initStickyFilter() {

    if (window.innerWidth < 992) {
        return
    }

    window.addEventListener("scroll", onScroll, {passive: true});
    window.addEventListener("resize", updateFilterPosition, {passive: true});
}


/**
 *
 */
function updateSelected() {
    const selectedKeys = Object.keys(selectedFilter);

    let html = selectedKeys.map(id => {
        return getNewSelected(selectedFilter[id].name, id)
    }).join('');

    if (selectedKeys.length > 1) {
        html += getNewSelected('Clear all', 'clear')
    }

    selectedListEl.innerHTML = html;

    if (selectedKeys.length) {
        const containerEl = selectedBoxEl.querySelector('.container');
        const h = containerEl ? containerEl.getBoundingClientRect().height : selectedListEl.getBoundingClientRect().height + (window.innerWidth < 768 ? 36 : 5);

        selectedBoxEl.style.maxHeight = h + 'px';
        filterTmpEl.style.height = h + 'px';
    } else {
        selectedBoxEl.style.maxHeight = '0';
    }

    setTimeout(() => updateFilterPosition(), 400)
}

/**
 *
 */
function updateFilterPosition() {
    if (window.innerWidth < 992) {
        return
    }

    selectedBoxEl.classList.remove('sticky');

    const headerHeight = 60;
    const rect = productEl.getBoundingClientRect();
    const rectFS = filterSection.getBoundingClientRect();
    const h = selectedBoxEl.getBoundingClientRect().height;
    const contentHeight = rectFS.height;
    const mh = contentHeight < filterEl.scrollHeight ? (contentHeight - headerHeight) + 'px' : 'none';
    const th = rectFS.top + contentHeight + window.pageYOffset;

    filterPosition.top = rect.top + window.pageYOffset - headerHeight;
    filterPosition.bottom = th - window.innerHeight;
    filterPosition.footer = th - headerHeight;
    filterPosition.selected = filterPosition.top - h;
    filterEl.style.maxHeight = mh;
    filterTmpEl.style.height = h + 'px';

    filterPosition.ts = rectFS.top - h + window.pageYOffset - headerHeight;

    onScroll();
}

/**
 *
 */
function onScroll() {
    const top = window.scrollY;
    const bottomEl = filterPosition.bottom;

    if (top > filterPosition.top) {
        filterColEl.classList.add('sticky');
        filterColEl.style.bottom = (top > bottomEl ? top - bottomEl : 0) + 'px';
    } else {
        filterColEl.classList.remove('sticky');
        filterColEl.style.bottom = 'auto';
    }

    if (top > filterPosition.ts) {
        selectedBoxEl.classList.add('sticky');
        selectedBoxEl.style.top = top > filterPosition.footer ? '-60px' : '60px';
    } else {
        selectedBoxEl.classList.remove('sticky');
    }

}

/**
 *
 * @param root
 * @param idx
 * @returns {string}
 */
function getNewFilter(root, idx) {
    if (!root.filterRootItems || root.filterRootItems.length === 0) {
        return ''
    }

    return `
        <div class="item">
            <input type="checkbox" class="toggle" id="f-toggle-${ idx }" style="display: none" onchange="onStateChange(${ idx }, this.checked)" ${ openState[root.id] || openStateZero[root.id] ? 'checked' : '' }>
            <label class="title ${ idx == 0 ? ' primary' : ''}" for="f-toggle-${ idx }">
                ${ root.name }
                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7" fill="none">
                    <path d="M1.61852 6.75C0.819821 6.75 0.34343 5.85985 0.786466 5.1953L3.91795 0.498075C4.31377 -0.0956581 5.18623 -0.0956575 5.58205 0.498076L8.71353 5.1953C9.15657 5.85985 8.68018 6.75 7.88148 6.75L1.61852 6.75Z"/>
                </svg>
            </label>
        ` + getItems(root.filterRootItems) + '</div>'

    function getItems(list) {
        return list.map(item => {
            return `
                <label class="item-row ${ item.productsCount == 0 ? 'disabled' : ''}">
                    <input type="checkbox" name="filter" onchange="filterChange(this, ${ item.productsCount })" id="${item.id}" ${ selectedFilter[item.id] ? 'checked' : '' }>
                    <span class="name">
                        ${ item.name } (${ item.productsCount })
                    </span>
                </label>
            `
        }).join('');
    }
}

/**
 *
 * @param group
 * @returns {string}
 */
function getNewProduct(group) {
    return `
        <h2 class="group-title">
            ${ group.formFactorCaption }
        </h2>
        ${ getDescription(group.description) }
        <div class="product-list-box">
            ${getItems(group.productPages)}
        </div>
    `;

    function getDescription(description) {
        return description ? `<p class="description">${ description }</p>` : '';
    }

    function getItems(list) {
        return list.map(item => {
            return `
                <div class="item">
                      ${ item.hasVideo === true ? `
                        <svg class="video-icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <title>Video review available.</title>
                        <path d="M23.498 6.188a3.02 3.02 0 0 0-2.122-2.136C19.505 3.547 12 3.547 12 3.547s-7.505 0-9.377.505A3.02 3.02 0 0 0 .502 6.188C0 8.072 0 12.002 0 12.002s0 3.93.502 5.814a3.02 3.02 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.02 3.02 0 0 0 2.122-2.136C24 15.932 24 12.002 24 12.002s0-3.93-.502-5.814M9.545 15.57V8.434l6.273 3.568z" fill="#FF0033">
                        </path></svg>` : ''}
                    <a href="${ item.link }" class="img-link">
                        <img data-src="${ item.img }" alt="${ item.alt }" class="model-img b-lazy" width="198" height="131" />
                    </a>
                    <div class="name-box">
                        <h3 class="name">
                            <a href="${ item.link }">
                                ${ item.name }
                            </a>
                        </h3>
                        ${ item.configuration ? `
                            <a href="${ item.configuration}" class="btn btn-primary">Configure</a>
                        ` : '' }

                        ${ item.shopNowLink ? `
                            <a href="${ item.shopNowLink }" class="btn btn-success">
                                Shop Now
                            </a>
                        ` : ''}

                        ${ !item.configuration || !item.shopNowLink ? `
                            <a href="${ item.link }" class="btn btn-success">
                                Details
                            </a>
                        ` : ''}
                    </div>
                </div>
            `
        }).join('');
    }
}

/**
 *
 * @param name
 * @param id
 * @param cls
 * @returns {string}
 */
function getNewSelected(name, id) {
    const cls = id === 'clear' ? 'item secondary' : 'item';

    return `
        <div class="${cls}">
            <span>${name}</span>
            <button onclick="removeSelected('${id}')">&#10005;</button>
        </div>
    `
}

function onStateChange(idx, state) {
    openState[idx] = state;
}

function removeSelected(id) {
    urlParams.delete('s');

    if (id === 'clear') {
        Object.keys(selectedFilter).forEach(id => delete selectedFilter[id]);
        filterStartRequest();
    } else {
        const input = document.getElementById(id);

        input.checked = false;
        filterChange(input, 1);
    }
}


global.filterChange = filterChange;
global.removeSelected = removeSelected;
global.onStateChange = onStateChange;

if (window.innerWidth > Utils.screen.xs) {
    init();
    initStickyFilter();
}
